import * as React from "react"

export default class NotFoundPage extends React.Component {
	public render() {
		return <div>404.</div>
	}
}
